import {CgArrowLongLeftC} from "react-icons/cg";

function BackLink({href}) {

  const iconStyle = {
    pointerEvents: 'none',
    width: '24px',
    height: '24px',
  }

  return (
    <a href={href} title="Назад" className="NavigationLink">
      <CgArrowLongLeftC style={iconStyle} />
    </a>
  );
}

export default BackLink;
